import styled from "styled-components";
import {FiltersMobileButtonDefaultBox} from "./filters-mobile-button.default.box";
import {ACTIVE} from "../../../../../themes/css-global-classes";

export const FiltersMobileButtonCasino777Box = styled(FiltersMobileButtonDefaultBox)`
  border: 2px solid ${props => props.theme.colors.moneyColor}80;
  border-radius: 5px;
  color: ${props => props.theme.colors.moneyColor};
  
  &.${ACTIVE} {
      &:after {
        top: -0.5rem;
        right: -0.5rem;
      }
  }
`;